<template>
  <div
    class="modal fade"
    :ref="`modal-apartment-type-img`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{ $t(titleModal) }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("apartment.apartmentContract.attachFile")
                }}</label>
                <div>
                  <div class="mt-3" style="position: relative;">
                    <label
                      :for="`upload-apartment-img${fileData.index}`"
                      class="custom-file-upload"
                    >
                      <i
                        class="glyphicon glyphicon-cloud-upload"
                        style="position: absolute; left: 10px; top: 30%; color: #cccccc; font-size: small;"
                      ></i>
                      <span style="font-size: small; word-wrap: break-word;">{{
                        fileNameData
                          ? fileNameData
                          : $t("newsManagement.residentNews.fileUpload")
                      }}</span>
                    </label>
                    <input
                      :id="`upload-apartment-img${fileData.index}`"
                      type="file"
                      accept="application/pdf"
                      @click="onOpenInputSelectFile"
                      @change="onSelectAssetImg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{ $t("common.fileName") }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="fileData.fileName"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import utils from "@/lib/utils";
// import Enum from "../../../enum/enum";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  props: {
    directoryUpload: {
      type: String,
      default: () => {
        return "pdfFile";
      }
    },
    titleModal: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  data: () => ({
    fileData: {
      id: 0,
      pdfUrl: null,
      fileName: null,
      index: null,
      isUpdate: false
    },
    pdfFileUploadSize: null,
    pdfFileUpload: null,
    media_server: {
      domain: "",
      token: ""
    },
    fileNameData: null
  }),
  watch: {
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    }
  },
  computed: {
    ...mapGetters([
      "GET_TOKEN_UPLOAD_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    onOpenInputSelectFile: function() {
      $(`#upload-apartment-img${this.fileData.index}`).val("");
      $(`#upload-apartment-img${this.fileData.index}`).click();
    },
    onShowAddNew: function(index) {
      $(this.$refs[`modal-apartment-type-img`]).modal("show");
      this.fileData = {
        id: 0,
        pdfUrl: null,
        fileName: null,
        index: index,
        isUpdate: false
      };
      this.fileNameData = null
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-apartment-type-img`]).modal("show");
      this.fileData = {
        id: data.id,
        pdfUrl: data.pdfUrl,
        fileName: data.fileName,
        index: data.index,
        isUpdate: true
      };
      let fileName = !utils.isEmptyString(data.pdfUrl) ? data.pdfUrl.split("/") : null;
      this.fileNameData = fileName[fileName.length - 1];
    },
    onCloseModal: function() {
      $(this.$refs[`modal-apartment-type-img`]).modal("hide");
    },
    onSave: async function() {
      if (utils.isEmptyString(this.fileData.pdfUrl)) {
        this.ON_SHOW_TOAST({
          message: this.$t("apartment.apartmentContract.attachFile"),
          styleType: "danger"
        });
      } else {
        if (!utils.isEmptyString(this.pdfFileUploadSize)) {
          await this.uploadPdfFile();
        }
        let data = {
          id: this.fileData.id,
          pdfUrl: this.fileData.pdfUrl,
          fileName: this.fileData.fileName,
          index: this.fileData.index
        };
        this.$emit("uploadPdfFileEmit", data);
        this.onCloseModal()
      }
    },
    // img function
    /**
     * Select issuance img
     */
    onSelectAssetImg: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.pdfFileUploadSize = files[0].size;
      this.fileNameData = files[0].name;
      this.fileData.pdfUrl = URL.createObjectURL(files[0]);
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.pdfFileUpload = file;
    },
    uploadPdfFile: async function() {
      if (this.pdfFileUploadSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.pdfFileUpload);
        formData.append("directory", this.directoryUpload);
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let pdfUrl = res.data.domain + res.data.url;
              this.fileData.pdfUrl = pdfUrl;
              this.pdfFileUploadSize = null
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}
input[type="file"] {
  display: none;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 30px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ComponentFilePdfWithFileName.vue